import React, { useState } from 'react';

import Button from 'components/Button/Button';

import useStyles from './styles';
import { useAuthApp } from 'hooks/useAuthApp';
import { useAppSelector } from 'store/hooks';
import { UserDataSelector } from 'store/user/selector';
import { tt } from '@i18n/tt';

const Profile: React.FC = () => {
  const [processing, setProcessing] = useState<boolean>(false);

  const classes = useStyles();
  const { handleLinking, handeUnlinking } = useAuthApp(setProcessing);

  const { googleLinked, microsoftLinked } = useAppSelector(UserDataSelector);

  return (
    <div className={classes.container}>
      <h3>{tt('pages.profile.externalLogin.title')}</h3>

      {microsoftLinked ? (
        <Button
          text={tt('pages.profile.externalLogin.unLinkMicrosoft')}
          onClick={() => {
            handeUnlinking(1);
          }}
          disabled={processing}
        />
      ) : (
        <Button
          text={tt('pages.profile.externalLogin.linkMicrosoft')}
          onClick={() => {
            handleLinking('Microsoft');
          }}
          disabled={processing}
        />
      )}

      {googleLinked ? (
        <Button
          text={tt('pages.profile.externalLogin.unLinkGoogle')}
          onClick={() => {
            handeUnlinking(2);
          }}
          disabled={processing}
        />
      ) : (
        <Button
          text={tt('pages.profile.externalLogin.linkGoogle')}
          onClick={() => {
            handleLinking('Google');
          }}
          disabled={processing}
        />
      )}
    </div>
  );
};

export default Profile;
